import * as React from 'react';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  children?: React.ReactNode;
}

const InputSearch = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, children, ...props }, ref) => {
    return (
      <div id="ai-search-input" className={className}>
        <input
          type={type}
          className={
            'peer/field block relative w-full bg-transparent text-whitegroup-disabled/input:text-[rgba(255,255,255,0.5)] ring-offset-background placeholder:text-[rgba(255,255,255,0.5)] focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 disabled:pointer-events-none z-10 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:m-0 [appearance:textfield]'
          }
          ref={ref}
          {...props}
        />
        {children}
      </div>
    );
  }
);
InputSearch.displayName = 'Input';

export { InputSearch };
